module.exports = __webpack_public_path__ + "img/close-gallery.392fdded.svg";